import { StoryboardFunctionRegistryFactory } from "../../StoryboardFunctionRegistry.js";
export const isolatedFunctionRegistry = new Map();
export function registerIsolatedFunctions(isolatedRoot, functions) {
  const {
    storyboardFunctions,
    registerStoryboardFunctions
  } = StoryboardFunctionRegistryFactory({
    isolatedRoot
  });
  isolatedFunctionRegistry.set(isolatedRoot, storyboardFunctions);
  registerStoryboardFunctions(functions);
}
//# sourceMappingURL=IsolatedFunctions.js.map